import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/tab_img.png'
import _imports_1 from '../assets/step.gif'
import _imports_2 from '../assets/get.png'
import _imports_3 from '../assets/ad.png'
import _imports_4 from '../assets/ad1.png'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "el_col" }
const _hoisted_3 = { class: "el_row" }
const _hoisted_4 = {
  class: "el_row",
  style: {"text-align":"left","width":"80%"}
}
const _hoisted_5 = { style: {"margin-left":"10px","color":"white"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RowScollView = _resolveComponent("RowScollView")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_CustomDialog = _resolveComponent("CustomDialog")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("body", _hoisted_1, [
    _createVNode(_component_el_container, { class: "home" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_main, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _cache[9] || (_cache[9] = _createElementVNode("img", {
                src: _imports_0,
                alt: "logo",
                class: "img_title"
              }, null, -1)),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_RowScollView)
              ]),
              _cache[10] || (_cache[10] = _createElementVNode("div", {
                class: "el_col",
                style: {"align-items":"flex-start","width":"70%","margin-top":"20px"}
              }, [
                _createElementVNode("img", {
                  src: _imports_1,
                  style: {"width":"300px"},
                  alt: "输入手机号"
                })
              ], -1)),
              _createVNode(_component_el_input, {
                class: "el_phone_input",
                type: "number",
                maxlength: "11",
                modelValue: _ctx.phone,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.phone) = $event)),
                placeholder: _ctx.input_phone_hinder,
                pattern: _ctx.pone_pattern
              }, null, 8, ["modelValue", "placeholder", "pattern"]),
              _createElementVNode("img", {
                src: _imports_2,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getGo())),
                class: "img"
              }),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_checkbox, {
                  onChange: _ctx.handleCheckChanged,
                  modelValue: _ctx.checked,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.checked) = $event)),
                  size: "large"
                }, null, 8, ["onChange", "modelValue"]),
                _createElementVNode("p", _hoisted_5, [
                  _cache[6] || (_cache[6] = _createTextVNode(" 我已阅读并同意")),
                  _createElementVNode("span", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.readInfo()))
                  }, "《服务协议》"),
                  _cache[7] || (_cache[7] = _createTextVNode("及")),
                  _createElementVNode("span", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.readInfo()))
                  }, "《隐私政策》"),
                  _cache[8] || (_cache[8] = _createTextVNode("，知悉业务说明并用该号码登录办理 "))
                ])
              ]),
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "el_row" }, [
                _createElementVNode("p", { class: "font_size" }, [
                  _createTextVNode(" 开通咪咕短剧超级会员,"),
                  _createElementVNode("strong", null, "标准资费20元/月"),
                  _createTextVNode("， 以"),
                  _createElementVNode("strong", null, "话费支付"),
                  _createTextVNode("，具体以实际扣费为准， 支付成功后"),
                  _createElementVNode("strong", null, "立即生效，未退订保持按月生效，费用按月扣取。"),
                  _createTextVNode("无合约期，订购期间可随时退订，无需承担违约责任。 可随时取消，取消"),
                  _createElementVNode("strong", null, "立即生效"),
                  _createTextVNode(",当前周期内可继续享受权益，次月起不再扣费。若需退订，可至"),
                  _createElementVNode("strong", null, "咪咕阅读APP-[我的]-[我的包月]-[订购管理]"),
                  _createTextVNode("退订。 ")
                ])
              ], -1)),
              _cache[12] || (_cache[12] = _createElementVNode("strong", { style: {"font-size":"20px","text-align":"center","color":"white"} }, "客服热线：4009685118", -1)),
              _cache[13] || (_cache[13] = _createElementVNode("img", {
                src: _imports_3,
                alt: "logo",
                class: "img_title"
              }, null, -1)),
              _cache[14] || (_cache[14] = _createElementVNode("img", {
                src: _imports_4,
                alt: "logo",
                style: {"margin-top":"20px"},
                class: "img_title"
              }, null, -1)),
              _cache[15] || (_cache[15] = _createElementVNode("p", { style: {"color":"white","font-size":"20px"} }, "业务规则", -1)),
              _cache[16] || (_cache[16] = _createElementVNode("div", {
                class: "el_col",
                style: {"color":"white","font-size":"18px","align-items":"flex-start","text-align":"left"}
              }, [
                _createElementVNode("p", { style: {"margin-left":"20px","margin-right":"20px"} }, [
                  _createTextVNode("1、产品名称：咪咕短剧超级会员。"),
                  _createElementVNode("br"),
                  _createTextVNode(" 2、产品资费："),
                  _createElementVNode("strong", null, "话费"),
                  _createTextVNode("支付"),
                  _createElementVNode("strong", null, "20元/月"),
                  _createElementVNode("br"),
                  _createTextVNode(" 3、产品对象："),
                  _createElementVNode("strong", null, "中国移动用户（不含港澳台用户）"),
                  _createTextVNode("。"),
                  _createElementVNode("br"),
                  _createTextVNode(" 4、生效时间：支付成功后"),
                  _createElementVNode("strong", null, "立即生效"),
                  _createTextVNode("，"),
                  _createElementVNode("strong", null, "未退订保持按月生效，费用按月扣取。"),
                  _createTextVNode(" 无合约期，订购期间可随时退订，无需承担违约责任。可随时取消，取消"),
                  _createElementVNode("strong", null, "立即生效"),
                  _createTextVNode("，当前周期内可继续享受权益，次月起不再扣费。 "),
                  _createElementVNode("br"),
                  _createTextVNode(" 5、产品内容： "),
                  _createElementVNode("strong", null, "咪咕短剧超级会员"),
                  _createTextVNode("可享全库畅看（含精品专区，极少数短剧内容因版权方限制，暂不支持免费观看）、免广告等权益。"),
                  _createElementVNode("br"),
                  _createTextVNode(" 6、权益领取："),
                  _createElementVNode("strong", null, "咪咕短剧超级会员权益"),
                  _createTextVNode("订购成功后，权益无需客户领取，立即直充到账，"),
                  _createElementVNode("strong", null, "请下载咪咕阅读APP"),
                  _createTextVNode("，用订购手机号码登录后，点击下方短剧导航-选择会员，即可观看喜欢的短剧。"),
                  _createElementVNode("br"),
                  _createTextVNode(" 7、咪咕短剧超级会员与咪咕短剧标准会员、各类咪咕短剧精品会员之间不互斥，用户可同时订购。订购后各会员权益同时生效，"),
                  _createElementVNode("strong", null, "权益时长不叠加延长，权益以最高的为准"),
                  _createTextVNode("。同一咪咕短剧连续包月产品，"),
                  _createElementVNode("strong", null, "每个用户每月仅能订购一次"),
                  _createTextVNode("。"),
                  _createElementVNode("br"),
                  _createTextVNode(" 8、办理须知：订购业务前请仔细阅读活动规则，订购本业务，即视为同意接受本业务及其相关活动的所有条款或规则。"),
                  _createElementVNode("br"),
                  _createTextVNode(" 9、"),
                  _createElementVNode("strong", null, "退订方式：可登录咪咕阅读APP-[我的]-[我的包月]-[订购管理]进行操作退订；也可联系客服咨询与退订4009685118。"),
                  _createElementVNode("br"),
                  _createTextVNode(" 10、如发生不可抗力、情势变更情形（包括但不限于因自然灾害、司法行政命令、公共服务故障、设备与系统维护或故障、网络信息与数据安全、外呼电话无法联系用户等）造成您订购、兑换、使用或变更相关权益障碍、延后或内容变更等情形，我们可依据法律法规的规定主张免责、采取适当应对措施。"),
                  _createElementVNode("br"),
                  _createTextVNode(" 11、客服咨询："),
                  _createElementVNode("br"),
                  _createTextVNode(" ①客服热线：4009685118，客服工作时间：周一到周日8:00-21:00，节假日无休"),
                  _createElementVNode("br"),
                  _createTextVNode(" ②在线客服：咪咕阅读APP-我的-帮助与客服-联系人工，工作时间：周一到周日08:30-22:00，节假日无休。 ")
                ])
              ], -1))
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_dialog, {
          modelValue: _ctx.centerDialogVisible,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.centerDialogVisible) = $event)),
          width: "500",
          "align-center": ""
        }, {
          default: _withCtx(() => _cache[17] || (_cache[17] = [
            _createElementVNode("div", { style: {"width":"100%","text-align":"left","font-size":"20px"} }, [
              _createElementVNode("p", null, "尊敬的客户："),
              _createElementVNode("p", null, "根据《中华人民共和国反恐怖主义法》、 《全国人民代表大会常务委员会关于加强网络信息保护的决定》、 《电信和互联网用户个人信息保护规定》（工业和信息化部令第24号）等国家法律法规的要求， 为更好地提供服务，需要客户提供如联系人、联系电话、通信地址、电子邮箱等信息。"),
              _createElementVNode("p", null, " 为向客户提供优质、个性化的服务，包括但不限于提供通信服务、 保障通信服务安全、改善服务质量、推介个性化产品等， 我公司将遵循合法、正当、必要的原则， 按照法律法规规定或协议约定使用留存客户个人信息， 并妥善保管，严格保密，依法保护客户个人信息。")
            ], -1)
          ])),
          _: 1,
          __: [17]
        }, 8, ["modelValue"]),
        (_ctx.showToast)
          ? (_openBlock(), _createBlock(_component_CustomDialog, {
              key: 0,
              close: _ctx.handColse
            }, null, 8, ["close"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}